import React from 'react';

export default function NewsItem({ item }) {
    return (
        <article className="stock-news-card">
            <div className="stock-news-inner">
                {item.image_url && (
                    <img
                        className="stock-news-thumb"
                        src={item.image_url}
                        alt=""
                        loading="lazy"
                    />
                )}
                <div className="stock-news-content">
                    <div className="stock-news-head">
                        <a
                            className="stock-news-title"
                            href={item.article_url}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {item.title}
                        </a>
                        {item.published_utc && (
                            <time className="stock-news-date">{item.published_utc}</time>
                        )}
                    </div>
                    {item.description && (
                        <p className="stock-news-desc">{item.description}</p>
                    )}
                </div>
            </div>
            {item.publisher && (
                <footer className="stock-news-footer">
                    <a
                        className="stock-news-publisher"
                        href={item.publisher.homepage_url}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {item.publisher.name}
                    </a>
                    {item.publisher.logo_url && (
                        <img
                            className="stock-news-publisher-logo"
                            src={item.publisher.logo_url}
                            alt={item.publisher.name}
                        />
                    )}
                </footer>
            )}
        </article>
    );
}
